module.exports = __webpack_public_path__ + "img/telesalud.98ae2110.png";